<template>
  <section class="relative md:py-24 py-16">
    <div class="container">
      <div class="grid grid-cols-1 pb-8 text-center">
        <h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Choose Pricing Plan</h3>

        <p class="text-slate-400 max-w-xl mx-auto">Start working with Techwind that can provide everything you need to
          generate awareness, drive traffic, connect.</p>
      </div><!--end grid-->

      <div class="grid lg:grid-cols-3 md:grid-cols-2 mt-8 gap-[30px]">
        <div
          class="group border-b-[3px] dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative shadow dark:shadow-gray-800 rounded-md bg-white dark:bg-slate-900">
          <div class="p-6 py-8">
            <h6 class="font-bold uppercase mb-5 text-indigo-600">Starter</h6>

            <div class="flex mb-5">
              <span class="text-xl font-semibold">$</span>
              <span class="price text-4xl font-semibold mb-0">39</span>
              <span class="text-xl font-semibold self-end mb-1">/mo</span>
            </div>

            <ul class="list-none text-slate-400">
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Full Access</li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Source Files</li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Free Appointments
              </li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Enhanced Security
              </li>
            </ul>
            <a href=""
              class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mt-5">Get
              Started</a>
          </div>
        </div>

        <div
          class="group border-b-[3px] dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative shadow dark:shadow-gray-800 rounded-md bg-white dark:bg-slate-900">
          <div class="p-6 py-8 md:pl-10">
            <h6 class="font-bold uppercase mb-5 text-indigo-600">Business</h6>

            <div class="flex mb-5">
              <span class="text-xl font-semibold">$</span>
              <span class="price text-4xl font-semibold mb-0">49</span>
              <span class="text-xl font-semibold self-end mb-1">/mo</span>
            </div>

            <ul class="list-none text-slate-400">
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Full Access</li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Source Files</li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Free Appointments
              </li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Enhanced Security
              </li>
            </ul>
            <a href=""
              class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mt-5">Try
              it Now</a>
          </div>
        </div>

        <div
          class="group border-b-[3px] dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative shadow dark:shadow-gray-800 rounded-md bg-white dark:bg-slate-900">
          <div class="p-6 py-8 md:pl-10">
            <h6 class="font-bold uppercase mb-5 text-indigo-600">Professional</h6>

            <div class="flex mb-5">
              <span class="text-xl font-semibold">$</span>
              <span class="price text-4xl font-semibold mb-0">59</span>
              <span class="text-xl font-semibold self-end mb-1">/mo</span>
            </div>

            <ul class="list-none text-slate-400">
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Full Access</li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Source Files</li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Free Appointments
              </li>
              <li class="mb-1 flex"><i class="uil uil-check-circle text-indigo-600 text-xl mr-2"></i> Enhanced Security
              </li>
            </ul>
            <a href=""
              class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mt-5">Try
              it Now</a>
          </div>
        </div>
      </div>
    </div><!--end grid-->
  </section>
</template>

<script>
export default {

}
</script>

<style></style>